import { createMiddleware } from '@shared/redux';
import { getMobeesCampaigns } from '@domain/partnerships/partners/mobees/campaign-table/campaign-table.state';
import { LOAD_STATE } from '@shared/axios';
import { showErrorToast, showSuccessToast } from '@shared/toasts/toasts.state';
import { SIGN_OUT } from '@domain/auth';
import {
    CREATE_STRIPE_CUSTOMER_REQUEST_FAILED,
    CREATE_STRIPE_CUSTOMER_REQUEST_SUCCEEDED,
    UPDATE_STRIPE_CUSTOMER_REQUEST_FAILED,
    UPDATE_STRIPE_CUSTOMER_REQUEST_SUCCEEDED,
} from '@domain/billing/stripe/stripe-customer';
import { PARTNERSHIPS_ROUTERS } from '@domain/partnerships/partnerships.constants';
import { getLocation } from 'connected-react-router';
import { resetInterface } from '../interface/interface.state';
import {
    POST_MOBEES_FORM_REQUEST_FAILED,
    POST_MOBEES_FORM_REQUEST_SUCCEEDED,
    RESET_MOBEES_FORM,
    HANDLE_SUBMIT_MOBEES_FORM,
    setMobeesFormLoadState,
    resetMobeesForm,
    postMobeesFormRequest,
} from './form.state';
import { MOBEES_FORM_ERROR_MESSAGE, MOBEES_FORM_SUCCESS_MESSAGE } from './form.constants';
import { resetAds } from '../ads/ad.state';
import { getCampaignSettings, resetCampaign } from '../campaign/campaign.state';

const submitMobeesFormOnStripeCustomerSuccess = (state) => {
    const { pathname: currentRoute } = getLocation(state);

    if (currentRoute === PARTNERSHIPS_ROUTERS.MOBEES) {
        const mobeesCampaign = getCampaignSettings(state);
        return postMobeesFormRequest(mobeesCampaign.data.id);
    }

    return [];
};

const handleWithStripeErrorInMobeesForm = (state) => {
    const { pathname: currentRoute } = getLocation(state);

    if (currentRoute === PARTNERSHIPS_ROUTERS.MOBEES) {
        return setMobeesFormLoadState(LOAD_STATE.FAIL);
    }

    return [];
};

export const mobeesFormMiddlewares = createMiddleware({
    [HANDLE_SUBMIT_MOBEES_FORM]: (state) => {
        const campaign = getCampaignSettings(state);
        return [postMobeesFormRequest(campaign.data.id)];
    },
    [POST_MOBEES_FORM_REQUEST_SUCCEEDED]: () => [
        resetMobeesForm(),
        setMobeesFormLoadState(LOAD_STATE.SUCCESS),
        getMobeesCampaigns(),
        showSuccessToast({ message: MOBEES_FORM_SUCCESS_MESSAGE }),
    ],
    [POST_MOBEES_FORM_REQUEST_FAILED]: () => [
        setMobeesFormLoadState(LOAD_STATE.FAIL),
        showErrorToast({ message: MOBEES_FORM_ERROR_MESSAGE }),
    ],
    [CREATE_STRIPE_CUSTOMER_REQUEST_SUCCEEDED]: submitMobeesFormOnStripeCustomerSuccess,
    [UPDATE_STRIPE_CUSTOMER_REQUEST_SUCCEEDED]: () => submitMobeesFormOnStripeCustomerSuccess,
    [CREATE_STRIPE_CUSTOMER_REQUEST_FAILED]: handleWithStripeErrorInMobeesForm,
    [UPDATE_STRIPE_CUSTOMER_REQUEST_FAILED]: handleWithStripeErrorInMobeesForm,
    [RESET_MOBEES_FORM]: () => [
        resetCampaign(),
        resetAds(),
        resetInterface(),
    ],
    [SIGN_OUT]: () => [resetMobeesForm()],
});
